import Nav from '../components/marketing/Nav';
import Ticker from '../components/marketing/Ticker';
import Hero from '../components/marketing/Hero';
import StatsBar from '../components/marketing/StatsBar';
import IntelBand from '../components/marketing/IntelBand';
import ResearchSection from '../components/marketing/ResearchSection';
import ProjectionEngine from '../components/marketing/ProjectionEngine';
import Features from '../components/marketing/Features';
import Pricing from '../components/marketing/Pricing';
import TrackRecord from '../components/marketing/TrackRecord';
import CTASection from '../components/marketing/CTASection';
import Footer from '../components/marketing/Footer';

export default function MarketingPage() {
  return (
    <>
      <Nav />
      <Ticker />
      <Hero />
      <StatsBar />
      <IntelBand />
      <ResearchSection />
      <ProjectionEngine />
      <Features />
      <Pricing />
      <TrackRecord />
      <CTASection />
      <Footer />
    </>
  );
}
